
import React, { useState } from 'react';
import '../../App.css';
import './Contact.css';
import Footer from '../Footer';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase';

function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [status, setStatus] = useState('idle');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('sending');

        try {
            const sendContactEmail = httpsCallable(functions, 'sendContactEmail');
            await sendContactEmail(formData);
            setStatus('success');
            setFormData({ name: '', email: '', subject: '', message: '' });
        } catch (error) {
            console.error('Error sending message:', error);
            setStatus('error');
        }
    };

    return (
        <>
            <div className='contact-hero' style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/couple.PNG)` }}>
                <div className='contact-hero-content'>
                    <h1>GET IN TOUCH</h1>
                    <p>We'd love to hear from you</p>
                </div>
            </div>

            <div className='contact-section'>
                <div className='contact-container'>
                    <div className='contact-info'>
                        <h2>DROP US A NOTE</h2>
                        <p>
                            Whether you have a question about our roasting classes,
                            want to collaborate, or just want to say hello — we're
                            here for you.
                        </p>
                        <div className='contact-detail'>
                            <i className='fas fa-envelope'></i>
                            <div>
                                <h4>EMAIL</h4>
                                <a href='mailto:info@offftheroast.com'>info@offftheroast.com</a>
                            </div>
                        </div>
                    </div>

                    <form className='contact-form' onSubmit={handleSubmit}>
                        {status === 'success' && (
                            <div className='contact-status contact-status--success'>
                                Message sent successfully! We'll get back to you soon.
                            </div>
                        )}
                        {status === 'error' && (
                            <div className='contact-status contact-status--error'>
                                Failed to send message. Please try again or email us directly.
                            </div>
                        )}
                        <div className='contact-form-row'>
                            <div className='contact-form-group'>
                                <label htmlFor='name'>Name</label>
                                <input
                                    type='text'
                                    id='name'
                                    name='name'
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder='Your name'
                                    required
                                    disabled={status === 'sending'}
                                />
                            </div>
                            <div className='contact-form-group'>
                                <label htmlFor='email'>Email</label>
                                <input
                                    type='email'
                                    id='email'
                                    name='email'
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder='Your email'
                                    required
                                    disabled={status === 'sending'}
                                />
                            </div>
                        </div>
                        <div className='contact-form-group'>
                            <label htmlFor='subject'>Subject</label>
                            <input
                                type='text'
                                id='subject'
                                name='subject'
                                value={formData.subject}
                                onChange={handleChange}
                                placeholder='Subject'
                                required
                                disabled={status === 'sending'}
                            />
                        </div>
                        <div className='contact-form-group'>
                            <label htmlFor='message'>Message</label>
                            <textarea
                                id='message'
                                name='message'
                                value={formData.message}
                                onChange={handleChange}
                                placeholder='Your message'
                                rows='6'
                                required
                                disabled={status === 'sending'}
                            ></textarea>
                        </div>
                        <button
                            type='submit'
                            className='contact-submit-btn'
                            disabled={status === 'sending'}
                        >
                            {status === 'sending' ? 'SENDING...' : 'SEND MESSAGE'}
                        </button>
                    </form>
                </div>
            </div>

            <Footer />
        </>
    );
}

export default Contact;
